import { BLOCKS } from './blocks.mjs';
export var EMPTY_DOCUMENT = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [{
    nodeType: BLOCKS.PARAGRAPH,
    data: {},
    content: [{
      nodeType: 'text',
      value: '',
      marks: [],
      data: {}
    }]
  }]
};